import {getDate, getDay, isValid} from 'date-fns';
import {parseDateExpression} from '@/model/utils/date';

type DateValidationOptions = {
  min?: string;
  max?: string;
};

export const validateDate =
  (options: DateValidationOptions = {}) =>
  (input: Date) => {
    if (!isValid(input)) return false;

    const {min, max} = options;

    const parsedMinDate = min ? parseDateExpression(min) : undefined;
    const parsedMaxDate = max ? parseDateExpression(max) : undefined;

    if (parsedMinDate) {
      parsedMinDate.setHours(0, 0, 0, 0);

      if (input.getTime() < parsedMinDate.getTime()) return false;
    }

    if (parsedMaxDate) {
      parsedMaxDate.setHours(0, 0, 0, 0);

      if (input.getTime() > parsedMaxDate.getTime()) return false;
    }

    return true;
  };

type DayOfTheMonthValidationOptions =
  | number
  | {
      min?: number;
      max?: number;
    };

export const validateDayOfTheMonth = (options: DayOfTheMonthValidationOptions) => (input: Date) => {
  if (!isValid(input)) return false;

  const day = getDate(input);

  if (typeof options === 'number') return day === options;

  if (day < (options.min ?? 1)) return false;
  if (day > (options.max ?? 31)) return false;

  return true;
};

export const validateDayOfTheWeek = (options: {in: number[]}) => (input: Date) => {
  if (!isValid(input)) return false;

  const day = getDay(input);

  return options.in.includes(day);
};

export const normalizeDateInput = (input: string): Date => {
  // We must replace '-' with '/' because otherwise it's assuming we want to substract date
  return new Date(input.replace(/-/g, '/'));
};
